/** Finder 風ソースリスト用の小さなインライン SVG（lucide 非依存） */

type IconProps = { className?: string }

function DecorativeSvg({
  className,
  children,
}: {
  className: string
  children: React.ReactNode
}) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  )
}

export function IconAllProjects({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <rect x="3" y="3" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="11" y="3" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="11" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="11" y="11" width="6" height="6" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    </DecorativeSvg>
  )
}

export function IconFolder({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <path
        d="M3 6.5A1.5 1.5 0 0 1 4.5 5H8l1.2 1.2H15.5A1.5 1.5 0 0 1 17 7.7v6.8A1.5 1.5 0 0 1 15.5 16h-11A1.5 1.5 0 0 1 3 14.5v-8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </DecorativeSvg>
  )
}

export function IconChevronRight({ className = 'h-3.5 w-3.5' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <path
        d="M8 5.5 12.5 10 8 14.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </DecorativeSvg>
  )
}

export function IconProject({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <rect x="4" y="3" width="12" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M7 7.5h6M7 10.5h6M7 13.5h3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </DecorativeSvg>
  )
}

export function IconUncategorized({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <rect x="3.5" y="3.5" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7 10h6M10 7v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </DecorativeSvg>
  )
}

export function IconTrash({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <path
        d="M7 4.5h6M8.5 4.5V3.8a.8.8 0 0 1 .8-.8h1.4a.8.8 0 0 1 .8.8v.7M5.5 4.5l.8 11.2a1.2 1.2 0 0 0 1.2 1.1h5a1.2 1.2 0 0 0 1.2-1.1l.8-11.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </DecorativeSvg>
  )
}

export function IconSettings({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <circle cx="10" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M10 3.2v1.4M10 15.4v1.4M3.2 10h1.4M15.4 10h1.4M5.2 5.2l1 1M13.8 13.8l1 1M5.2 14.8l1-1M13.8 6.2l1-1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </DecorativeSvg>
  )
}

export function IconPlan({ className = 'h-4 w-4' }: IconProps) {
  return (
    <DecorativeSvg className={className}>
      <path
        d="M4 6.5A1.5 1.5 0 0 1 5.5 5h9A1.5 1.5 0 0 1 16 6.5v7A1.5 1.5 0 0 1 14.5 15h-9A1.5 1.5 0 0 1 4 13.5v-7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M4 8h12" stroke="currentColor" strokeWidth="1.5" />
    </DecorativeSvg>
  )
}
